const baseUri = `${ import.meta.env.VITE_SITE_URL }/crms/agreements`;

export default {
  list: async (query = {}) => {
    return await axios.get(`${ baseUri }`, {
      params: {
        ...query,
        list: true,
      },
    });
  },
};
